"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = Navigation;
const react_1 = __importStar(require("react"));
const AppBar_1 = __importDefault(require("./AppBar"));
const Drawer_1 = require("./Drawer");
const store_1 = __importDefault(require("store"));
Navigation.Context = (0, react_1.createContext)({
    isDrawerOpen: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggleDrawer: () => { },
});
function Navigation({ logoUrl, logoAltText, logoRedirect, userContent, appBarClassName = undefined, drawerClassName = undefined, drawerContent = undefined, contextChooser, }) {
    const [isDrawerOpen, setIsDrawerOpen] = (0, react_1.useState)(store_1.default.get('navigation_drawer_open', true));
    const handleDrawerToggle = (0, react_1.useCallback)(() => {
        setIsDrawerOpen(!isDrawerOpen);
        store_1.default.set('navigation_drawer_open', !isDrawerOpen);
    }, [setIsDrawerOpen, isDrawerOpen]);
    return (react_1.default.createElement(Navigation.Context.Provider, { value: { isDrawerOpen, toggleDrawer: handleDrawerToggle } },
        react_1.default.createElement(AppBar_1.default, { logoUrl: logoUrl, logoAltText: logoAltText, logoRedirect: logoRedirect, userContent: userContent, className: appBarClassName, contextChooser: contextChooser }),
        !!drawerContent && (react_1.default.createElement(Drawer_1.Drawer, { drawerOpen: isDrawerOpen, onToggleDrawer: handleDrawerToggle, drawerContent: drawerContent, className: drawerClassName }))));
}
